<template>
    <!-- <b-modal ref="mdlSchedaInfermieristica" title="Scheda Infermieristica" @hidden="onCloseModal" @ok="onSalvaSchedaInfermieristica" centered no-close-on-backdrop no-close-on-esc hide-header-close size="xl" scrollable @show="onShow"> -->
    <b-row>
        <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
            <rsa-scheda-infermieristica-anamnesi-patologica-remota-edit-component :jsonDataApr="jsonData.schedaInfermieristicaAnamnesiPatologicaRemota" @update="onUpdateSchedaInfermieristicaAnamnesiPatologicaRemota" :isReadOnly="isReadOnly" :id-accettazione="idAccettazione" ref="cmpApr" />
        </b-col>

        <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
            <rsa-scheda-infermieristica-anamnesi-patologica-prossima-edit-component :jsonData="jsonData.schedaInfermieristicaApp" @update="onUpdateSchedaInfermieristicaApp" :isReadOnly="isReadOnly" :id-accettazione="idAccettazione" ref="cmpAnamnesiPatologicaProssima" />
        </b-col>

        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
            <rsa-scheda-infermieristica-valutazione-sensoriale-edit-component :jsonDataValutazioneSensoriale="jsonData.schedaInfermieristicaValutazioneSensoriale" @update="onUpdateSchedaInfermieristicaValutazioneSensoriale" :id-accettazione="idAccettazione" :isReadOnly="isReadOnly" ref="cmpValutazioneSensoriale" />
        </b-col>

        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
            <rsa-scheda-infermieristica-valutazione-escretoria-edit-component @update="onUpdateSchedaInfermieristicaValutazioneEscretoria" :jsonDataValutazioneEscretoria="jsonData.schedaInfermieristicaValutazioneEscretoria" :id-accettazione="idAccettazione" :isReadOnly="isReadOnly" ref="cmpValutazioneEscretoria" />
        </b-col>

        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
            <rsa-scheda-infermieristica-riposo-sonno-edit-component @update="onUpdateSchedaInfermieristicaRiposoSonno" :jsonDataRiposoSonno="jsonData.schedaInfermieristicaRiposoSonno" :id-accettazione="idAccettazione" :isReadOnly="isReadOnly" ref="cmpRiposoSonno" />
        </b-col>

        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
            <rsa-scheda-infermieristica-valutazione-adl-edit-component @update="onUpdateSchedaInfermieristicaValutazioneAdl" :jsonDataValutazioneAdl="jsonData.schedaInfermieristicaValutazioneAdl" :id-accettazione="idAccettazione" :isReadOnly="isReadOnly" ref="cmpValutazioneAdl" />
        </b-col>

        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
            <rsa-scheda-infermieristica-valutazione-dermatologica-edit-component @update="onUpdateSchedaInfermieristicaValutazioneDermatologica" :jsonDataValutazioneDermatologica="jsonData.schedaInfermieristicaValutazioneDermatologica" :id-accettazione="idAccettazione" :isReadOnly="isReadOnly" ref="cmpValutazioneDermatologica" />
        </b-col>

        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
            <rsa-scheda-infermieristica-valutazione-preferenze-edit-component @update="onUpdateSchedaInfermieristicaValutazionePreferenze" :jsonDataValutazionePreferenze="jsonData.schedaInfermieristicaValutazionePreferenze" :id-accettazione="idAccettazione" :isReadOnly="isReadOnly" ref="cmpValutazionePreferenze" />
        </b-col>

        <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
            <b-card class="sa-card sa-card-border" header="Note Scheda" header-tag="header" footer-tag="footer" title="">
                <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                    <span v-if="isReadOnly">{{ jsonData.note }}</span>
                    <b-form-textarea v-else v-model="jsonData.note" :readonly="isReadOnly" max-rows="10" rows="7"> </b-form-textarea>
                </b-col>
            </b-card>
        </b-col>
    </b-row>
    <!-- <template #modal-footer>
            <b-button v-if="!isReadOnly" variant="outline-danger" @click="$refs.mdlSchedaInfermieristica.hide()">Annulla</b-button>
            <b-button v-if="!isReadOnly" variant="outline-success" @click="onSalvaSchedaInfermieristica()">Salva</b-button>
            <b-button v-if="isReadOnly" variant="outline-primary" @click="$refs.mdlSchedaInfermieristica.hide()"> Chiudi </b-button>
        </template>
    </b-modal> -->
</template>

<script>
import RsaSchedaInfermieristicaValutazionePreferenzeEditComponent from "./RsaSchedaInfermieristicaValutazionePreferenzeEditComponent.vue";
import UtilityMixin from "../../../utility/UtilityMixin";
import RsaSchedaInfermieristicaValutazioneDermatologicaEditComponent from "./RsaSchedaInfermieristicaValutazioneDermatologicaEditComponent.vue";
import RsaSchedaInfermieristicaAnamnesiPatologicaRemotaEditComponent from "./RsaSchedaInfermieristicaAnamnesiPatologicaRemotaEditComponent.vue";
import RsaSchedaInfermieristicaValutazioneSensorialeEditComponent from "./RsaSchedaInfermieristicaValutazioneSensorialeEditComponent.vue";
import RsaSchedaInfermieristicaValutazioneEscretoriaEditComponent from "./RsaSchedaInfermieristicaValutazioneEscretoriaEditComponent.vue";
import RsaSchedaInfermieristicaRiposoSonnoEditComponent from "./RsaSchedaInfermieristicaRiposoSonnoEditComponent.vue";
import RsaSchedaInfermieristicaValutazioneAdlEditComponent from "./RsaSchedaInfermieristicaValutazioneAdlEditComponent.vue";
import RsaSchedaInfermieristicaAnamnesiPatologicaProssimaEditComponent from "./RsaSchedaInfermieristicaAnamnesiPatologicaProssimaEditComponent.vue";
export default {
    mixins: [UtilityMixin],
    components: {
        RsaSchedaInfermieristicaAnamnesiPatologicaRemotaEditComponent,
        RsaSchedaInfermieristicaValutazioneSensorialeEditComponent,
        RsaSchedaInfermieristicaValutazioneEscretoriaEditComponent,
        RsaSchedaInfermieristicaRiposoSonnoEditComponent,
        RsaSchedaInfermieristicaValutazioneAdlEditComponent,
        RsaSchedaInfermieristicaValutazioneDermatologicaEditComponent,
        RsaSchedaInfermieristicaValutazionePreferenzeEditComponent,
        RsaSchedaInfermieristicaAnamnesiPatologicaProssimaEditComponent,
    },
    props: {
        idRisorsa: {
            type: String,
            default: function () {
                return null;
            },
        },
        idAccettazione: {
            type: String,
            default: function () {
                return null;
            },
        },
        isReadOnly: {
            type: Boolean,
        },
    },
    data() {
        return {
            pathResourceDizionario: "/rsadizionario",
            pathResourceSchedaInfermieristica: "/rsaschedainfermieristica",
            pathResourceCheckSchedaInfermieristica: "/rsaschedainfermieristica/check",
            jsonData: {
                id: null,
                idAccettazione: null,
                note: null,
                schedaInfermieristicaAnamnesiPatologicaRemota: {
                    id: null,
                    idAccettazione: this.idAccettazione,
                    accessiVenosiPeriferici: null,
                    patologiaPrincipale: "",
                    emotrasfusionali: null,
                    patologiaConcomitanti: "",
                    reazioniTrasfusionali: null,
                    note: "",
                },
                schedaInfermieristicaApp: {
                    id: null,
                    idAccettazione: this.idAccettazione,
                    sintomatologiaAttuale: "",
                    complianceTerapeutica: null,
                    terapiaAntalgica: null,
                    terapiaAntalgicaDescrizione: "",
                    dolore: "",
                    note: "",
                },
                schedaInfermieristicaRiposoSonno: {
                    id: null,
                    idAccettazione: this.idAccettazione,
                    disturboSonno: null,
                    riposoPomeridiano: null,
                    usoIpnoinducenti: null,
                    descrizioneSonno: "",
                    descrizioneRiposo: "",
                    descrizioneIpnoinducenti: "",
                    note: "",
                },
                schedaInfermieristicaValutazioneAdl: {
                    id: null,
                    idAccettazione: this.idAccettazione,
                    abbigliamentoAspettoIgienico: null,
                    capacitaCuraAutonoma: null,
                    note: "",
                    listaSchedaAdlDettaglio: [],
                },
                schedaInfermieristicaValutazioneDermatologica: {
                    id: null,
                    idAccettazione: this.idAccettazione,
                    decubiti: "",
                    mucose: null,
                    mucoseDescrizione: "",
                    note: "",
                    listaDermatologaCute: [],
                    listaDermatologaUnghie: [],
                },
                schedaInfermieristicaValutazioneEscretoria: {
                    id: null,
                    idAccettazione: this.idAccettazione,
                    incontinenzaUrinaria: null,
                    incontinenzaFecale: null,
                    urinaria: null,
                    intesticale: null,
                    pannoloniGiornalieri: 0,
                    strisceAssorbentiGiornalieri: 0,
                    traverseGiornaliere: 0,
                    note: "",
                },
                schedaInfermieristicaValutazionePreferenze: {
                    id: null,
                    idAccettazione: this.idAccettazione,
                    abitudine: "",
                    ciboGradito: "",
                    ciboSgradito: "",
                    alterazioneApportoAlimentare: "",
                    note: "",
                },
                schedaInfermieristicaValutazioneSensoriale: {
                    id: null,
                    idAccettazione: this.idAccettazione,
                    vista: null,
                    udito: null,
                    olfatto: null,
                    gusto: null,
                    note: null,
                    sensibilita: null,
                    consapevolezzaMalattia: null,
                },
            },
        };
    },
    mounted() {
        let me = this;
        me.jsonData.idAccettazione = me.idAccettazione;
        if (me.idRisorsa !== null) {
            me.loadData();
        }
    },
    watch: {
        jsonData: {
            handler(jsonData) {
                this.$emit("update", jsonData);
            },
            deep: true,
        },
    },
    methods: {
        loadData() {
            let me = this;
            // console.log("idAccettazione LoadGeneraleData", me.idAccettazione);
            me.key++;
            let path = process.env.VUE_APP_PATH_API + me.pathResourceSchedaInfermieristica + "/" + me.idRisorsa;
            UtilityMixin.methods.restCallGet(path, null, me.loadDataSuccess, me.loadDataError);
        },
        loadDataSuccess(response) {
            let me = this;
            me.jsonData = response.data.data;

            // Object.assign(me.jsonData, response.data.data);
            // console.log("SONO NELLA RISPOSTA DI SUCCESSO DEL LOAD DATA RICHIAMATO NEL MOUNTED DI QUESTO COMPONENTE SE IL MOUNTED TROVA UN idRisorsa dal livello 2 [3° LIVELLO]: ", me.jsonData);
        },
        loadDataError(error) {
            let me = this;
            me.$emit("afterLoadData", error);
            me.$bvToast.toast("Errore durante il caricamento", {
                title: "Errore",
                variant: "danger",
                solid: true,
            });
        },

        onUpdateSchedaInfermieristicaAnamnesiPatologicaRemota(data) {
            let me = this;
            me.jsonData.schedaInfermieristicaAnamnesiPatologicaRemota = data;
        },
        onUpdateSchedaInfermieristicaApp(data) {
            let me = this;
            me.jsonData.schedaInfermieristicaApp = data;
        },
        onUpdateSchedaInfermieristicaRiposoSonno(data) {
            let me = this;
            me.jsonData.schedaInfermieristicaRiposoSonno = data;
        },
        onUpdateSchedaInfermieristicaValutazioneAdl(data) {
            let me = this;
            me.jsonData.schedaInfermieristicaValutazioneAdl = data;
        },
        onUpdateSchedaInfermieristicaValutazioneDermatologica(data) {
            let me = this;
            me.jsonData.schedaInfermieristicaValutazioneDermatologica = data;
        },
        onUpdateSchedaInfermieristicaValutazioneEscretoria(data) {
            let me = this;
            me.jsonData.schedaInfermieristicaValutazioneEscretoria = data;
        },
        onUpdateSchedaInfermieristicaValutazionePreferenze(data) {
            let me = this;
            me.jsonData.schedaInfermieristicaValutazionePreferenze = data;
        },
        onUpdateSchedaInfermieristicaValutazioneSensoriale(data) {
            let me = this;
            me.jsonData.schedaInfermieristicaValutazioneSensoriale = data;
        },
        /* show(value, isReadOnly) {
            let me = this;
            me.isReadOnly = isReadOnly;
            me.$refs.mdlSchedaInfermieristica.show();
            value;
            console.log("VALUE IN  SHOW: IL LOG ENTRA SOLO QUANDO AGGIUNGO UNA SCHEDA [3° LIVELLO]", value);
        }, 
        
        resetForm() {
            let me = this;
            me.jsonData = {
                id: null,
                idAccettazione: me.idAccettazione,
                note: null,
            };
        },     
        */
        // onSalvaSchedaInfermieristica() {
        //     let me = this;
        //     me.jsonData.idAccettazione = me.idAccettazione;
        //     /* console.log("Salvataggio SCHEDA INFERMIERISTICA con dati: ", JSON.stringify(me.jsonData)); */
        //     if (!me.jsonData.idAccettazione) {
        //         // console.log("idAccettazione: ", me.jsonData.idAccettazione);
        //         me.$bvToast.toast("Errore: ID Accettazione mancante", {
        //             title: "Errore",
        //             variant: "danger",
        //             solid: true,
        //         });
        //         return;
        //     }
        //     UtilityMixin.methods.saveResource(me.pathResourceSchedaInfermieristica, me.jsonData, me.saveSchedaInfermieristicaSuccessResponse, me.saveSchedaInfermieristicaErrorResponse);
        //     me.$refs.cmpApr.onSalvaApr();
        //     me.$refs.cmpAnamnesiPatologicaProssima.onSalvaAnamnesiPatologicaProssima();
        //     me.$refs.cmpValutazioneSensoriale.onSalvaValutazioneSensoriale();
        //     me.$refs.cmpValutazioneEscretoria.onSalvaValutazioneEscretoria();
        //     me.$refs.cmpRiposoSonno.onSalvaRiposoSonno();
        //     me.$refs.cmpValutazioneAdl.onSalvaValutazioneAdl();
        //     me.$refs.cmpValutazioneDermatologica.onSalvaValutazioneDermatologica();
        //     me.$refs.cmpValutazionePreferenze.onSalvaValutazionePreferenze();
        // },

        // saveSchedaInfermieristicaSuccessResponse(response) {
        //     let me = this;
        //     console.log("SCHEDA INFERMIERISTICA salvato con successo:", response);
        //     me.$emit("afterSaveSuccess");

        //     me.$refs.mdlSchedaInfermieristica.hide();
        //     me.$bvToast.toast("Salvataggio avvenuto con successo", {
        //         title: "Successo",
        //         variant: "success",
        //         solid: true,
        //     });
        // },
        // saveSchedaInfermieristicaErrorResponse(response) {
        //     let me = this;
        //     if (response.response.status === 400) {
        //         me.$bvModal.msgBoxOk(response.response.data.messaggio, {
        //             title: "ATTEZIONE",
        //             size: "md",
        //             okVariant: "outline-secondary",
        //             headerClass: "sa-msg-header-danger",
        //             footerClass: "p-2 border-top-0",
        //             centered: true,
        //         });
        //     } else {
        //         me.$bvToast.toast("Errore nel salvataggio in edit component" + response.message, {
        //             title: "Errore",
        //             variant: "danger",
        //             solid: true,
        //         });
        //     }
        // },

        /* onCloseModal() {
            let me = this;
            me.resetForm();
            me.$emit("onCloseModal");
        },
        onShow() {
            let me = this;
            me.loadData();
        }, */
    },
};
</script>
